export var DeviceMode;
(function (DeviceMode) {
  DeviceMode[DeviceMode["New"] = 1] = "New";
  DeviceMode[DeviceMode["ChangeName"] = 2] = "ChangeName";
})(DeviceMode || (DeviceMode = {}));